'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Poller = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

exports.pollNotifier = pollNotifier;

var _immutable = require('immutable');

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

var _notifiers = require('./notifiers');

var _notifiers2 = _interopRequireDefault(_notifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*
 * The Polling class is a way to have introspection into the polling process (if desired).  It allows a custom
 * timeout class.
 *
 * Options:
 *   onSetTimeout: Callback that accepts two arguments  The first argument is the function to call when the timer fires.
  *                The second argument is the interval (in milliseconds) that the timer should fire at.  The signature
  *                is exactly the same as `setTimeout` which is the default.
 *   onClearTimeout: Callback that accepts one argument.  The argument is the function to call to clear the timer. The
 *                   signature is exactly the same as `clearTimeout` which is the default.
 *   interval: The interval to poll on.
 */
var Poller = exports.Poller = (_class = function () {
  function Poller(options) {
    _classCallCheck(this, Poller);

    //noinspection UnnecessaryLocalVariableJS
    var _options$onSetTimeout = options.onSetTimeout,
        onSetTimeout = _options$onSetTimeout === undefined ? setTimeout : _options$onSetTimeout,
        _options$onClearTimeo = options.onClearTimeout,
        onClearTimeout = _options$onClearTimeo === undefined ? clearTimeout : _options$onClearTimeo,
        _options$interval = options.interval,
        interval = _options$interval === undefined ? 30000 : _options$interval;


    this.onSetTimeout = onSetTimeout;
    this.onClearTimeout = onClearTimeout;
    this.interval = interval;

    // Bookkeeping
    this._timer = null;
    this._subscriptions = (0, _immutable.Map)();
  }

  _createClass(Poller, [{
    key: 'start',
    value: function start() {
      if (!this.timer) {
        this._setTimer();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!!this.timer) {
        this._clearTimer();
      }
    }

    /*
     * Subscribe an id to a channel and store the function to use when the channel is notified.
     */

  }, {
    key: 'subscribe',
    value: function subscribe(id, channel, onNotify) {
      var _this = this;

      var isFirst = this._subscriptions.isEmpty();
      var channelSubscriptions = this._subscriptions.get(channel);
      if (channelSubscriptions === undefined) {
        // Subscribe to the channel
        channelSubscriptions = (0, _immutable.Map)();
        channelSubscriptions = channelSubscriptions.set(id, onNotify); // Purposely done after to keep type of id
        this._subscriptions = this._subscriptions.set(channel, channelSubscriptions);
      } else {
        this._subscriptions = this._subscriptions.setIn([channel, id], onNotify);
      }

      // Start the timer if this is the first subscription
      if (!!isFirst) {
        this.start();
      }

      return function () {
        return _this._unsubscribe(id, channel);
      };
    }

    /*
     * Unsubscribe an id from a channel
     */

  }, {
    key: '_unsubscribe',
    value: function _unsubscribe(id, channel) {
      var channelSubscriptions = this._subscriptions.get(channel);
      if (channelSubscriptions !== undefined) {
        // Remove the tag from the channel
        channelSubscriptions = channelSubscriptions.delete(id);
        if (channelSubscriptions.isEmpty()) {
          // No more subscribers to this channel.  Unsubscribe from the server.
          this._subscriptions = this._subscriptions.delete(channel);
        } else {
          // There is still at least 1 subscriber.  Just update the tracking list.
          this._subscriptions = this._subscriptions.set(channel, channelSubscriptions);
        }

        // Stop the timer if there are no more subscriptions
        if (this._subscriptions.isEmpty()) {
          this.stop();
        }
      }
    }

    /*
     * Perform all functions required when the timer fires.
     */

  }, {
    key: '_timerCallback',
    value: function _timerCallback() {
      this._clearTimer();
      this._notifySubscriptions();
      this._setTimer();
    }

    /*
     * Set a new timer
     */

  }, {
    key: '_setTimer',
    value: function _setTimer() {
      var onSetTimeout = this.onSetTimeout;
      this._timer = onSetTimeout(this._timerCallback, this.interval);
    }

    /*
     * Clear the timer
     */

  }, {
    key: '_clearTimer',
    value: function _clearTimer() {
      if (!!this._timer) {
        var onClearTimeout = this.onClearTimeout;
        onClearTimeout(this._timer);
      }
      this._timer = null;
    }

    /*
     * Walk all subscriptions and call their notify function
     */

  }, {
    key: '_notifySubscriptions',
    value: function _notifySubscriptions() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._subscriptions.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              channel = _step$value[0],
              subscriptions = _step$value[1];

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = subscriptions.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                  id = _step2$value[0],
                  onNotify = _step2$value[1];

              onNotify();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'onSetTimeout',
    get: function get() {
      return this._onSetTimeout;
    },
    set: function set(newOnSetTimeout) {
      if (!!this._timer) {
        throw new Error("Can't change onSetTimeout function while timer is running.  Please call stop() first.");
      }
      this._onSetTimeout = newOnSetTimeout;
    }
  }, {
    key: 'onClearTimeout',
    get: function get() {
      return this._onClearTimeout;
    },
    set: function set(newOnClearTimeout) {
      if (!!this._timer) {
        throw new Error("Can't change onClearTimeout function while timer is running.  Please call stop() first.");
      }
      this._onClearTimeout = newOnClearTimeout;
    }
  }]);

  return Poller;
}(), (_applyDecoratedDescriptor(_class.prototype, '_timerCallback', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_timerCallback'), _class.prototype)), _class);

/*
 * Notifier to use for simple polled subscriptions.  (The notifier will
 */

var PollingNotifier = function (_Notifier) {
  _inherits(PollingNotifier, _Notifier);

  function PollingNotifier() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$requiresAuthenti = _ref.requiresAuthentication,
        requiresAuthentication = _ref$requiresAuthenti === undefined ? false : _ref$requiresAuthenti,
        options = _objectWithoutProperties(_ref, ['requiresAuthentication']);

    _classCallCheck(this, PollingNotifier);

    var _this2 = _possibleConstructorReturn(this, (PollingNotifier.__proto__ || Object.getPrototypeOf(PollingNotifier)).call(this));

    _this2.requiresAuthentication = requiresAuthentication;
    var poller = options.poller;

    if (poller === undefined) {
      poller = new Poller(options);
    }
    _this2.poller = poller;
    return _this2;
  }

  _createClass(PollingNotifier, [{
    key: 'onStart',
    value: function onStart() {
      this.poller.start();
    }
  }, {
    key: 'onStop',
    value: function onStop() {
      this.poller.stop();
    }
  }, {
    key: 'onLogin',
    value: function onLogin(authenticationPayload) {
      if (this.requiresAuthentication) {
        this.onStart();
      }
    }
  }, {
    key: 'onLogout',
    value: function onLogout() {
      if (this.requiresAuthentication) {
        this.onStop();
      }
    }
  }, {
    key: 'onSubscribe',
    value: function onSubscribe(subscribeId, channel, onNotify) {
      return this.poller.subscribe(subscribeId, channel, onNotify);
    }
  }]);

  return PollingNotifier;
}(_notifiers2.default);

function pollNotifier() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new PollingNotifier(options);
}